export default {
    type: 'text',
    config: {
        minWidth: {
            desktop: 200,
            mobile: 120
        },
        align: 'left'
    },
    default: {
        label: 'Version'
    },
    unique: [],
    lang: {
        name: 'Game Version',
        views: ['list','sheet'],
        contexts: ['collecton'],
        category: 'Game',
        description: 'Version name of the game.'
    }
}